import styles from "./text.module.scss";
import Icon from "../../icons/Icon";
import React from "react";
import { CheckmarkB500, ChevronrightG900 } from "../../icons/18";

export const BlockText = ({
  backgroundColor = "#fafafa",
  title = "",
  desc = "",
  showIcon = true,
  iconType = "arrow",
  style = {},
  onClick,
}: {
  backgroundColor?: string;
  title?: string | React.ReactNode;
  desc?: string | React.ReactNode;
  showIcon?: boolean;
  iconType?: "check" | "arrow";
  style?: React.CSSProperties;
  onClick?: () => void;
}) => {
  return (
    <>
      <div
        className={`${styles["text"]} ${styles["block"]}`}
        style={{
          backgroundColor: backgroundColor,
        }}
        onClick={() => {
          onClick && onClick();
        }}
      >
        <div className={styles["text-item"]}>
          <div
            className={styles["text-contents"]}
            style={{
              ...style,
            }}
          >
            {title && <h3 className={styles["text-title"]}>{title}</h3>}
            {desc && <p className={styles["text-desc"]}>{desc}</p>}
            {showIcon && (
              <Icon
                IconComponent={iconType === "check" ? <CheckmarkB500 /> : <ChevronrightG900 />}
                size={18}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
